<template>
  <div
    :class="listClass"
    @mouseover="$emit('showToolTip', $event, formattedValue)"
    @mouseleave="$emit('hideToolTip')"
  >
    <div v-for="(stat, index) in status" :class="getStatusClass(stat)" :key="index"></div>
    <div v-if="fullLength" class="statusLabel">{{ formattedValue[0] }}</div>
    <div class="clear-float"></div>
  </div>
</template>
<script>
import { includes, every } from 'lodash';

const isValidStatus = (status) => {
  return status && includes([
    'Reviewed',
    'Review Requested',
    'No Review Requested',
  ], status);
};

export default {
  name: 'reviewStatusIcons',
  props: {
    status: {
      type: Array,
      validator: (value) => {
        return Array.isArray(value) && value.length > 0 && every(value, isValidStatus);
      },
    },
    fullLength: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listClass() {
      return `status-array-${this.status.length}`;
    },
    formattedValue() {
      if (this.status.length > 1) {
        return ['Multiple'];
      }
      return this.status;
    },
  },
  methods: {
    getStatusClass(value) {
      if (value) {
        let updateValueFormat = value.trim();
        if (updateValueFormat.indexOf(' ') >= 0) {
          updateValueFormat = updateValueFormat.split(' ').join('-');
        }
        return `status-icons ${updateValueFormat && updateValueFormat.toLowerCase()}`;
      }
      return 'status-icons';
    },
  },
};
</script>
<style lang="scss" scoped>
.status-array {
  .clear-float {
    margin: 0;
    clear: both;
  }
  &-1 {
    position: relative;
    height: 18px;
    display: flex;
    .statusLabel {
      line-height: 18px;
      padding-left: $mds-space-inset-three-quarter-x;
    }
  }
  &-2 {
    width: 100%;
    div:not(:first-child):not(.statusLabel) {
      margin-left: -8px;
    }
    div:first-child {
      position: relative;
      z-index: 4;
    }
    div:nth-child(2) {
      position: relative;
      z-index: 3;
    }
    .statusLabel {
      margin: 0;
      line-height: 18px;
      float: left;
      padding-left: $mds-space-inset-three-quarter-x;
    }
  }
  &-3 {
    width: 100%;
    div:not(:first-child):not(.statusLabel) {
      margin-left: -8px;
    }
    div:first-child {
      position: relative;
      z-index: 4;
    }
    div:nth-child(2) {
      position: relative;
      z-index: 3;
    }
    div:nth-child(3) {
      position: relative;
      z-index: 2;
    }
    .statusLabel {
      margin: 0;
      line-height: 18px;
      float: left;
      padding-left: $mds-space-inset-three-quarter-x;
    }
  }
}

div.status-icons {
  width: 18px;
  height: 18px;
  float: left;
  background-repeat: no-repeat;
  background-position: center center;
  &.reviewed {
    background-image: url("/static/assets/reviewed.svg");
  }
  &:first-child.reviewed {
    background-image: url("/static/assets/reviewed.svg");
  }
  &.review-requested {
    background-image: url("/static/assets/review_requested.svg");
  }
  &:first-child.review-requested {
    background-image: url("/static/assets/review_requested.svg");
  }
  &.no-review-requested {
    background-image: url("/static/assets/no_review_requested.svg");
  }
  &:first-child.no-review-requested {
    background-image: url("/static/assets/no_review_requested.svg");
  }
}
</style>
